<template>
  <div class="home">
    <mouse-pointer />
    <landing-section />
    <about-section />
    <services-section />
    <approach-section />
    <clients-section />
    <contact-section />
    <newsletter-section />
    <footer-section />
  </div>
</template>

<script>
import mousePointer from '@/components/mouse-pointer'
import landing from '@/components/sections/landing.vue'
import about from '@/components/sections/about.vue'
import services from '@/components/sections/services.vue'
import approach from '@/components/sections/approach.vue'
import clients from '@/components/sections/clients.vue'
import contact from '@/components/sections/contact.vue'
import newsletter from '@/components/sections/newsletter.vue'
import footer from '@/components/sections/footer.vue'

export default {
  name: 'Home',
  components: {
    'mouse-pointer': mousePointer,
    'landing-section': landing,
    'about-section': about,
    'services-section': services,
    'approach-section': approach,
    'clients-section': clients,
    'contact-section': contact,
    'newsletter-section': newsletter,
    'footer-section': footer
  }
}
</script>

<style lang="scss" scoped>
.home {
  position: relative;
}
</style>
